module.exports = __webpack_public_path__ + "static/media/3DPPA12.b3bff878.jpg";